/* do not edit. this file is generated by npm run lib:icons and constantly overwritten */
import React from 'react'
/**
 * @deprecated Use icons from `@chilipiper/icons/figma-generated/src/icon` or
 *   `@chilipiper/icons/figma-generated/src/logo` instead
 */
export const SvgMeet = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width={16}
    height={16}
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M9.05029 8.08211L10.6099 9.86476L12.707 11.205L13.0727 8.09308L12.707 5.05068L10.5697 6.22815L9.05029 8.08211Z'
      fill='#00832D'
    />
    <path
      d='M0 10.9161V13.5672C0 14.1733 0.490915 14.6642 1.09702 14.6642H3.74814L4.29665 12.6603L3.74814 10.9161L1.92892 10.3676L0 10.9161Z'
      fill='#0066DA'
    />
    <path
      d='M3.74814 1.5L0 5.24814L1.92892 5.79665L3.74814 5.24814L4.28751 3.52765L3.74814 1.5Z'
      fill='#E94235'
    />
    <path d='M3.74814 5.24814H0V10.9161H3.74814V5.24814Z' fill='#2684FC' />
    <path
      d='M15.1022 3.08702L12.707 5.05068V11.2049L15.1131 13.1778C15.4733 13.4593 15.9999 13.2024 15.9999 12.7444V3.5112C15.9999 3.04771 15.4615 2.79357 15.1022 3.08702ZM9.0503 8.08211V10.9161H3.74805V14.6642H11.61C12.2161 14.6642 12.707 14.1733 12.707 13.5672V11.2049L9.0503 8.08211Z'
      fill='#00AC47'
    />
    <path
      d='M11.61 1.5H3.74805V5.24814H9.0503V8.0821L12.707 5.05251V2.59702C12.707 1.99092 12.2161 1.5 11.61 1.5Z'
      fill='#FFBA00'
    />
  </svg>
)
export default SvgMeet
